
import Vue from 'vue'

export default Vue.extend({
  name: 'SidebarShippingDates',
  props: {
    singleColorShippingDate: {
      type: String,
      required: true
    },
    fullColorShippingDate: {
      type: String,
      required: true
    },
    singleColorSampleShippingDate: {
      type: String as () => string | null,
      required: false,
      default: null
    },
    fullColorSampleShippingDate: {
      type: String as () => string | null,
      required: false,
      default: null
    },
    currentCategory: {
       type: Object as () => {[key: string]: string | number},
      required: true
    }
  },
  methods: {
    clearFacetStorage(){
      location.href = `/search?category=${this.currentCategory.id}&sortorder=delivery_date_asc`
    }
  }
})
